import Component from '../abstracts/Component';

export default class CarouselComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousels(elem);
      },
      error => {
        console.error('failed to load slick ', error.stack);
      }
    );
  }

  initCarousels(elem) {
    let selector = this.SELECTORS.main;
    let carousels = [];
    if (elem != null && typeof elem != 'undefined' && document.getElementsByClassName(elem).length)
      carousels = document.getElementsByClassName(elem);
    else carousels = document.querySelectorAll(selector);

    for (let carousel of carousels) {
      const slides = typeof carousel.dataset.slides != 'undefined' ? Number(carousel.dataset.slides) : 1;
      const visibleItemsMobile = typeof carousel.dataset.visibleItemsXs != 'undefined' ? Number(carousel.dataset.visibleItemsXs) : slides;
      const visibleItemsTablet = typeof carousel.dataset.visibleItemsMd != 'undefined' ? Number(carousel.dataset.visibleItemsMd) : slides;
      const visibleItemsDesktop = typeof carousel.dataset.visibleItemsLg != 'undefined' ? Number(carousel.dataset.visibleItemsLg) : slides;
      const isDots = carousel.dataset.dots === 'true' ? true : false;
      const isFade = carousel.dataset.fade === 'true' ? true : false;
      const isCenter = carousel.dataset.centerslick === 'true' ? true : false;
      const isArrows = carousel.dataset.arrows === 'true' ? true : false;
      const prevArrow = carousel.dataset.customarrows === 'true' ? '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button>' : '<button type="button" class="w__slick-prev icon-slick-prev" aria-label="previous slide"><!-- --></button>';
      const nextArrow = carousel.dataset.customarrows === 'true' ? '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button>' : '<button type="button" class="w__slick-next icon-slick-next" aria-label="next slide"><!-- --></button>'
      const isAccessible = carousel.dataset.accessibility === 'true' ? true : false;
      const isAutoplay = carousel.dataset.autoplay === 'true' ? true : false;
      const isDraggable = carousel.dataset.draggable === 'false' ? false : true;
      const isInfinite = carousel.dataset.infinite === 'true' ? true : false;
      const autoplaySpeed = typeof carousel.dataset.autoplaySpeed != 'undefined' ? carousel.dataset.autoplaySpeed : 3000;
      const slidesToScroll = typeof carousel.dataset.slidesToScroll != 'undefined' ? Number(carousel.dataset.slidesToScroll) : 1;
      const isVariableWidth = carousel.dataset.variablewidth === 'true' ? true : false;

      let options = {
        dots: isDots,
        arrows: isArrows,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: isInfinite,
        centerMode: isCenter,
        autoplay: isAutoplay,
        autoplaySpeed: autoplaySpeed,
        accessibility: isAccessible,
        draggable: isDraggable,
        slidesToShow: slides,
        slidesToScroll: slidesToScroll,
        fade: isFade,
        variableWidth: isVariableWidth
      };

      let responsiveArray = this.setResponsiveArray(visibleItemsMobile, visibleItemsTablet, visibleItemsDesktop);

      options = $.extend({}, options, {
        responsive: responsiveArray
      });

      const editMode = carousel.dataset.editMode === 'true' ? true : false;
      if (editMode) return false;

      const onlyMobile = carousel.dataset.onlyMobile === 'true' ? true : false;

      let checkItems = slides;
      if(window.matchMedia('(max-width:767px)').matches || onlyMobile)
        checkItems = visibleItemsMobile;
      else if(window.matchMedia('(max-width:1280px)').matches)
        checkItems = visibleItemsTablet;

      if ( (carousel.children.length < checkItems) || !$(carousel).is(':visible')) {
        this.log('Carousel not triggered');
      } else if (window.matchMedia('(max-width:767px)').matches && onlyMobile) {
        $(carousel).slick(options);
        this.log('Carousel Triggered');
      } else if (!onlyMobile) {
        $(carousel).slick(options);
        this.log('Carousel Triggered');
      }
    }
  }

  setResponsiveArray(visibleItemsMobile, visibleItemsTablet, visibleItemsDesktop) {
    let responsiveArray = [];
    if (visibleItemsMobile == 'unslick') {
      responsiveArray.push({
        breakpoint: 767,
        settings: visibleItemsMobile
      });
    } else {
      responsiveArray.push({
        breakpoint: 767,
        settings: {
          slidesToShow: visibleItemsMobile,
        }
      });
    }
    if (visibleItemsTablet == 'unslick') {
      responsiveArray.push({
        breakpoint: 1279,
        settings: visibleItemsTablet
      });
    } else {
      responsiveArray.push({
        breakpoint: 1279,
        settings: {
          slidesToShow: visibleItemsTablet,
        }
      });
    }
    //set only if not a carousel in desktop else use default configs
    if (visibleItemsDesktop == 'unslick') {
      responsiveArray.push({
        breakpoint: 60000,
        settings: visibleItemsDesktop
      });
    }
    return responsiveArray;
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      console.log('afterOpen Modal')
        let carouselsIntoVex = document.querySelector('.vex').querySelectorAll('[data-carousel="in-vex"]');
      if (carouselsIntoVex.length > 0) {
        for(let carouselInVex of carouselsIntoVex){
            carouselInVex.dataset.carousel = 'true';
        }
          this.initCarousels();
      }
    });

    this.$on(this.$customEvents.CAROUSEL.triggerCarousel, data => {
      this.importLibrary(data.payload);
    });
  }

  render() {
    super.render();
    if (document.querySelectorAll('[data-carousel]').length)
      this.importLibrary();
    this.bindEvents();
  }
}
